import { render } from "./MyTimesheet.vue?vue&type=template&id=be87e348"
import script from "./MyTimesheet.vue?vue&type=script&lang=js"
export * from "./MyTimesheet.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__